import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import styles from './OperationalCoherenceCard.module.css'

interface OperationalCoherenceCardProps {
    score: number | undefined;
    maxScore: number | undefined;
    status: string | undefined;
}

export function OperationalCoherenceCard({ score = 0, maxScore = 0, status }: OperationalCoherenceCardProps) {


    const setMessage = () => {
        if (status === 'ACORDO') {
            return (
                <div className='margin-top-20'>
                    Operação coerente! A quilometragem executada está <span className='text-bold'>compatível</span> com o contrato.
                </div>
            )
        } else if (status === 'DESACORDO') {
            return (
                <div className='margin-top-20'>
                    Divergência de quilometragem. A operação real <span className='text-bold'>difere</span> do limite declarado em contrato.
                </div>
            )
        }
    }

    return (
        <StatsWidgets>
            <StatsWidget className='shadow-default'>
                <StatsWidget.Header>Coerência Operacional</StatsWidget.Header>
                <StatsWidget.Body className='padding-20'>
                    <div className={styles['score-container']}>
                        <div className='text-center'>
                            <div>
                                <div style={{ fontSize: 40 }}>
                                    <span className={styles["current-score"]}>{score}</span>
                                    <span className={styles["total-score"]}>/ {maxScore}</span>
                                </div>
                                {score === maxScore ? (
                                    <div className='margin-top-10'>
                                        <div className="label text-size-12 label-success">
                                            Pontuação Máxima! <span className='rioglyph rioglyph-trophy'></span>
                                        </div>
                                    </div>
                                ) : (
                                    null
                                )}
                            </div>
                        </div>
                        <div>
                            {setMessage()}
                        </div>
                    </div>
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    );
}